import { Currency } from '../locale/currencies';

export const formatNumber = ({
  value,
  currency,
  maximumFractionDigits = 2,
  notation,
}: {
  value: number;
  currency?: Currency;
  maximumFractionDigits?: number;
  notation?: 'compact';
}): string => {
  const locale = undefined;

  const options: Intl.NumberFormatOptions = {
    ...(currency ? { style: 'currency', currency } : {}),
    maximumFractionDigits,
    ...(notation ? { notation } : {}),
  };

  return new Intl.NumberFormat(locale, options).format(value);
};
